import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ isAdmin, loading, children }) => {
    if (loading) return <div>Loading...</div>;
    return isAdmin ? children : <Navigate to="/admin/login" />;
};

export default ProtectedRoute;
